import { render, staticRenderFns } from "./my-products-v2.tab.vue?vue&type=template&id=59b2daa5&scoped=true"
import script from "./my-products-v2.tab.vue?vue&type=script&lang=js"
export * from "./my-products-v2.tab.vue?vue&type=script&lang=js"
import style0 from "./my-products-v2.tab.vue?vue&type=style&index=0&id=59b2daa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b2daa5",
  null
  
)

export default component.exports